import React, { useState, useEffect } from "react"
import { withBase } from "constants/basePath"

import { useHistory, useParams } from "react-router-dom"

import { Button, Form } from "reactstrap"
import { AiOutlineWarning } from "react-icons/ai"

import { modalStyle } from "constants/layout"

import Tooltip from "components/Tooltip/Tooltip"

import Modal from "components/Modal/MaterialModal"
import RouterPrompt from "../Prompt/RouterPrompt"
import userStore from "userStore"

import { FiSave } from "react-icons/fi"
import { useMediaQuery } from "react-responsive"

import ModalActions from "./Modal"

import { IoMdArrowRoundBack } from "react-icons/io"

import "../tooltip.scss"

const Actions = ({
  save,
  modificacion,
  formik,
  loading,
  solicitud,
  buttonText,
  title,
}) => {
  const history = useHistory()
  const { id } = useParams()

  const changes = userStore(state => state.changes)
  const accionesSolicitud = userStore(state => state.accionesSolicitud)
  const idAccionWorkflow = userStore(state => state.idAccionWorkflow)

  const [goback, setGoback] = useState(false)
  const [showSolicitudAcciones, setShowSolicitudAcciones] = useState(false)

  const [warnings, setWarnings] = useState([])

  const [action] = useState({})

  const [open, setOpen] = useState(false)
  const toggle = () => setOpen(!open)

  const isMobileOrTablet = useMediaQuery({ query: "(max-width: 767px)" })
  const isMobile = useMediaQuery({ query: "(max-width: 575px)" })

  const getWarnings = warnings => {
    const warningsArray = []
    warnings.forEach(warning => {
      warningsArray.push(warning)
      warningsArray.push("<br />")
    })
    return warningsArray
  }

  const actionsModal = { ...modalStyle, width: isMobile ? "90%" : 400 }

  useEffect(() => {
    if (location.pathname === withBase(`/solicitud/${id}`)) {
      if (accionesSolicitud) {
        setShowSolicitudAcciones(true)
      } else {
        setShowSolicitudAcciones(false)
      }
    } else {
      setShowSolicitudAcciones(true)
    }
  }, [
    solicitud?.workflowItem?.actividadWorkflow?.acciones.length,
    accionesSolicitud,
  ])

  useEffect(() => {
    if (solicitud?.warnings?.length > 0) {
      setWarnings(getWarnings(solicitud.warnings))
    }
  }, [solicitud?.warnings?.length])

  useEffect(() => {
    if (idAccionWorkflow == null) {
      setOpen(false)
    }
  }, [idAccionWorkflow])

  return (
    <div
      className="d-flex mb-3 align-items-center"
      style={{ height: 30, marginTop: -1 }}
    >
      <Button
        onClick={() => {
          setGoback(true)
          if (changes) {
            history.push(history.location.pathname)
          } else {
            history.goBack()
          }
        }}
        className="d-flex align-items-center p-0 m-0 shadow-none border-0 me-1"
        color=""
      >
        <IoMdArrowRoundBack size={22} />
      </Button>
      <div className="d-flex align-items-center gap-1 gap-md-2">
        <h1 className="card-title mb-0 ms-1 font-size-20 fw-700">
          {isMobile ? title?.replace("Solicitud |", "") : title}
        </h1>
        {warnings?.length > 0 && (
          <div className="ms-1">
            <Tooltip
              title={
                <div>
                  {warnings.map((warning, index) => (
                    <p className="mb-0" key={index}>
                      {warning}
                    </p>
                  ))}
                </div>
              }
            >
              <span>
                <AiOutlineWarning size={21} color="var(--bs-warning)" />
              </span>
            </Tooltip>
          </div>
        )}
      </div>
      {modificacion && save && showSolicitudAcciones && (
        <Form
          id="modalId"
          className="ms-auto"
          onSubmit={formik ? formik.handleSubmit : ""}
        >
          <div className="d-flex align-items-center gap-2 gap-sm-3">
            <Button
              color="primary"
              type="submit"
              className="shadow-none"
              disabled={loading}
              onClick={() => userStore.setState({ changes: false })}
            >
              {buttonText ||
                (isMobileOrTablet ? <FiSave size={15} /> : "Guardar")}
            </Button>
            <RouterPrompt
              when={changes}
              handleSubmit={formik.handleSubmit}
              onOK={() => true}
              onCancel={() => false}
              setGoback={setGoback}
              goback={goback}
            />
            <Modal
              modal={open}
              toggle={toggle}
              modalHeader="Ejecutar acción"
              customStyles={actionsModal}
            >
              <ModalActions
                values={formik.values}
                onChange={formik.handleChange}
                action={action}
                toggle={toggle}
                onClick={() =>
                  userStore.setState({ idAccionWorkflow: action.id })
                }
              />
            </Modal>
          </div>
        </Form>
      )}
    </div>
  )
}

export default Actions
